












import {Component, Prop, Vue} from 'vue-property-decorator';
import {Category} from '@/models/category';

@Component
export default class PostCategory extends Vue {
  @Prop()
  private categories!: Map<string, Category>;
  get categoryList(): Category[] {
    if (this.categories) {
      return Object.values(this.categories).map(value => value);
    }
    return [];
  }
}
